import {GoodgamePartners} from '../../../constants/GoodgamePartners';
import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";
import { IVersionInformation } from "../../IVersionInformation";
import { XML, XMLList, XMLNode } from "@goodgamestudios/xml-e4x";


export class BasicWodData {
    protected wodXML: XML;
    protected _wodXMLList: Map<number, XML>;
    private versionXmlInfo: IVersionInformation;

    constructor(wodXML: XML) {
        this.versionXmlInfo = EnvGlobalsHandler.globals.versionInformation;
        this.wodXML = wodXML;
        this.parseWodXML();
        this.versionXmlInfo.parseItemXML(wodXML);
    }

    protected parseWodXML(): void {
        let xmlWodList: XMLNode[] = (this.wodXML.elements("wods") as any).children();
        let wodElement: XML;
        this._wodXMLList = new Map<number, XML>();

        for (wodElement of xmlWodList) {
            let id: number = parseInt(wodElement.attribute("wodID"));
            this._wodXMLList.set(id, wodElement);
        }
    }

    /**
     * validate world specific vo's
     *
     * @params world:int
     * @return Boolean
     *
     */
    protected voIsForWorld(world: number): boolean {
        let env: IEnvironmentGlobals = EnvGlobalsHandler.globals;

        switch (world) {
            case 0:
                return true;
            case 1:
                return (env.isLocal || GoodgamePartners.NETWORK_GENERAL == env.networkId || !env.hasNetworkBuddies);
            case 2:
                return (env.hasNetworkBuddies);
            default:
                return true;
        }
    }
}

